// Editable seed defaults. Source facts and illustrative values are distinguished here.
export const STORAGE_KEY = "praachin-admin-demo-v1";
const LEGACY_VERSION = 2;
export const VERSION = 5;
import { upgrade, customerExamples } from "../utils/domain/operations.js";
export const IDENTITY = {
  name: "Shraddha Gunjal",
  designation: "Founder & MD",
  company: "Necteria Foods Private Limited",
  brand: "Praachin Organics",
  businessEmail: "Info@praachinorganics.com",
  phone: "8390109960",
  avatar: "",
};
export const ASSETS = [
  ["cow-ghee.jpeg", "Cow Ghee"],
  ["buffalo-ghee.jpeg", "Buffalo Ghee"],
  ["wildforest-honey.jpeg", "Wildforest Honey"],
  ["jamun-honey.jpeg", "Jamun Honey"],
  ["acacia-honey.jpeg", "Acacia Honey"],
  ["saffron-honey.jpeg", "Saffron Honey"],
  ["saffron-honey-alt.jpeg", "Saffron Honey"],
  ["neem-honey.jpeg", "Neem Honey"],
  ["tulsi-honey.jpeg", "Tulsi Honey"],
  ["hazelnut-coffee.png", "Hazelnut Coffee"],
  ["ragi-chips.png", "Ragi Chips"],
  ["beetroot-chips.png", "Beetroot Chips"],
  ["makhana-peri-peri.png", "Makhana Peri Peri"],
].map(([file, name]) => ({
  path: "assets/" + file,
  name,
  label: name + (file.includes("-alt") ? " · alternate" : ""),
}));
const catalogue = [
  ["Cow Ghee", "INDRA", 500, "ml", 589, "cow-ghee.jpeg", "Original", 32],
  [
    "Buffalo Ghee",
    "INDRA",
    500,
    "ml",
    549,
    "buffalo-ghee.jpeg",
    "Original",
    24,
  ],
  ["Desi Bilona Gir Cow Ghee", "INDRA", 500, "ml", 1399, "", "Original", 12],
  [
    "Wildforest Honey",
    "VANYA",
    250,
    "g",
    299,
    "wildforest-honey.jpeg",
    "Wildforest",
    46,
  ],
  ["Jamun Honey", "VANYA", 250, "g", 299, "jamun-honey.jpeg", "Jamun", 28],
  ["Acacia Honey", "VANYA", 250, "g", 299, "acacia-honey.jpeg", "Acacia", 35],
  ["Saffron Honey", "VANYA", 250, "g", 389, "saffron-honey.jpeg", "Saffron", 7],
  ["Neem Honey", "VANYA", 250, "g", 299, "neem-honey.jpeg", "Neem", 18],
  ["Tulsi Honey", "VANYA", 250, "g", 299, "tulsi-honey.jpeg", "Tulsi", 22],
  ["Classic Coffee", "KALA", 100, "g", 599, "", "Classic", 30],
  ["Pre-workout Coffee", "KALA", 100, "g", 649, "", "Pre-workout", 16],
  [
    "Hazelnut Coffee",
    "KALA",
    100,
    "g",
    649,
    "hazelnut-coffee.png",
    "Hazelnut",
    20,
  ],
  ["Vanilla Coffee", "KALA", 100, "g", 649, "", "Vanilla", 0],
  ["Kesar Elaichi Tea", "KALA", 150, "g", 389, "", "Kesar Elaichi", 25],
  ["Baked Millet Bhujiya", "SUTRA", 150, "g", 179, "", "Original", 26],
  ["Ragi Chips", "SUTRA", 150, "g", 199, "ragi-chips.png", "Original", 8],
  [
    "Beetroot Chips",
    "SUTRA",
    150,
    "g",
    199,
    "beetroot-chips.png",
    "Original",
    21,
  ],
  [
    "Makhana Peri Peri",
    "SUTRA",
    70,
    "g",
    249,
    "makhana-peri-peri.png",
    "Peri Peri",
    15,
  ],
];
export function emptyProduct(id, skuId) {
  return {
    id,
    name: "",
    collection: "INDRA",
    variant: "Original",
    status: "Draft",
    launch: false,
    archived: false,
    photos: [],
    description: "",
    ingredients: "",
    nutrition: "",
    allergens: "",
    shelfLife: "",
    storage: "",
    manufacturer: "",
    marketer: "",
    fssai: "",
    taxRate: null,
    complianceVerified: false,
    infoMode: "reference",
    skus: [
      {
        id: skuId,
        code: "",
        variant: "Original",
        qty: null,
        unit: "g",
        mrp: null,
        price: null,
        stock: 0,
        threshold: 5,
        weight: null,
        dimensions: "",
      },
    ],
    provenance: {},
  };
}
const referenceFood = {
  INDRA: {
    ingredients:
      "Illustrative ingredient example: milk fat (ghee). Confirm the complete manufacturer-approved ingredient statement.",
    nutrition:
      "Illustrative layout per 100 g: energy 900 kcal; total fat 100 g; carbohydrate 0 g; protein 0 g. Sample values only, not verified label nutrition.",
    allergens:
      "Illustrative reference: contains milk. Confirm all declarations and cross-contact statements.",
    shelfLife:
      "Illustrative shelf-life setting: 12 months unopened. Replace with the approved best-before period.",
  },
  VANYA: {
    ingredients:
      "Illustrative ingredient example: honey. Infused variants may require additional ingredients; use the approved label statement.",
    nutrition:
      "Illustrative layout per 100 g: energy 304 kcal; carbohydrate 82 g; total sugars 82 g; fat 0 g; protein 0 g. Sample values only, not verified label nutrition.",
    allergens:
      "Illustrative reference: confirm the manufacturer’s allergen and cross-contact declaration; no allergen-free claim is approved.",
    shelfLife:
      "Illustrative shelf-life setting: 18 months unopened. Replace with the approved best-before period.",
  },
  KALA: {
    ingredients:
      "Illustrative ingredient example: coffee or tea with variant-specific flavouring. Confirm the ingredient list and flavour declarations for this SKU.",
    nutrition:
      "Illustrative dry-product layout per 100 g: energy 350 kcal; carbohydrate 60 g; protein 10 g; fat 8 g. Sample values only, not verified nutrition and not a serving recommendation.",
    allergens:
      "Illustrative reference: flavour ingredients may require milk or tree-nut declarations. Confirm each variant’s actual allergens.",
    shelfLife:
      "Illustrative shelf-life setting: 12 months unopened. Replace with the approved best-before period.",
  },
  SUTRA: {
    ingredients:
      "Illustrative ingredient example: product-specific grain, vegetable or makhana base, edible oil and seasoning. Replace with the exact approved ingredient statement.",
    nutrition:
      "Illustrative layout per 100 g: energy 480 kcal; carbohydrate 65 g; total fat 20 g; protein 8 g; fibre 8 g. Sample values only, not verified label nutrition.",
    allergens:
      "Illustrative reference: confirm cereal, milk, nut and seasoning allergens and cross-contact statements for this SKU.",
    shelfLife:
      "Illustrative shelf-life setting: 6 months unopened. Replace with the approved best-before period.",
  },
};
function legacySeed() {
  const products = catalogue.map((x, i) => {
    const [name, collection, qty, unit, mrp, file, variant, stock] = x;
    let p = emptyProduct("p" + (i + 1), "s" + (i + 1));
    Object.assign(p, {
      name,
      collection,
      variant,
      status: stock ? "Active" : "Out of Stock",
      launch: true,
      description: `${name}, packed in a ${qty} ${unit} format for the ${collection} collection. A convenient addition to your everyday pantry. Product copy is an editable reference draft.`,
      storage:
        "Reference guidance: keep sealed in a cool, dry place away from direct sunlight. Follow the approved packaging label.",
      ingredients:
        "Reference field: enter the complete ingredient list from the approved packaging label.",
      nutrition:
        "Reference field: attach or enter the label-approved nutrition table per 100 g / serving.",
      allergens:
        collection === "INDRA"
          ? "Reference: milk-based product. Confirm the full allergen declaration on the label."
          : "Reference: confirm allergens and cross-contact details with the manufacturer.",
      shelfLife:
        "Reference: use the best-before period printed on the approved pack.",
      manufacturer:
        "Reference: manufacturer name and address to be confirmed from the label.",
      marketer:
        "Necteria Foods Private Limited · address and label wording to be confirmed.",
      photos: file ? ["assets/" + file] : [],
      skus: [
        {
          id: "s" + (i + 1),
          code: `PO-${collection}-${String(i + 1).padStart(3, "0")}-${qty}${unit.toUpperCase()}`,
          variant,
          qty,
          unit,
          mrp,
          price: mrp,
          stock,
          threshold: 8,
          weight: Math.round(qty * (unit === "ml" ? 1.5 : 1.8) + 80),
          dimensions: unit === "ml" ? "10 × 10 × 15" : "9 × 9 × 17",
        },
      ],
      provenance: {
        name: "source",
        mrp: i < 14 ? "source" : "editable example default",
        quantity:
          i >= 4 && i <= 8 ? "pack-based implementation default" : "source",
        operational: "editable example defaults",
        foodDetails: "reference; unverified",
        regulatory: "unverified",
      },
    });
    Object.assign(p, referenceFood[collection]);
    return p;
  });
  const collections = [
    ["INDRA", "Ghee & traditional dairy craftsmanship", true],
    ["VANYA", "Honey & nature’s sweetness", true],
    ["SUTRA", "Chips, makhana & millet snacks", true],
    ["KALA", "Tea & coffee rituals", true],
    ["VEDA", "Spices & traditional ingredients", false],
    ["AADIVASI", "Natural & dehydrated powders", false],
    ["BHOOMI", "Products from the land", false],
  ].map(([id, description, launch], i) => ({
    id,
    code: id,
    name: id,
    description,
    launch,
    order: i + 1,
    image: "",
    archived: false,
  }));
  const customers = [
    {
      id: "c1",
      name: "Meera Kulkarni",
      email: "meera.kulkarni@example.com",
      phone: "",
      city: "Pune",
      note: "Prefers delivery updates by email.",
      exampleRecord: true,
    },
    {
      id: "c2",
      name: "Arjun Shah",
      email: "arjun.shah@example.com",
      phone: "",
      city: "Mumbai",
      note: "Asked about the coffee collection.",
      exampleRecord: true,
    },
    {
      id: "c3",
      name: "Nisha Rao",
      email: "nisha.rao@example.com",
      phone: "",
      city: "Bengaluru",
      note: "Interested in a mixed pantry order.",
      exampleRecord: true,
    },
  ];
  const orders = [
    {
      id: "PO-1001",
      customerId: "c1",
      date: "2026-09-25",
      items: [snapshot(products[0], products[0].skus[0], 1)],
      shipping: 60,
      discount: 0,
      status: "Pending",
      paymentId: "TX-1001",
      tracking: "",
      carrier: "",
      stockReserved: false,
      cancelRestored: false,
      note: "Email delivery update requested.",
      exampleRecord: true,
    },
    {
      id: "PO-1002",
      customerId: "c2",
      date: "2026-09-26",
      items: [snapshot(products[3], products[3].skus[0], 2)],
      shipping: 0,
      discount: 0,
      status: "Processing",
      paymentId: "TX-1002",
      tracking: "",
      carrier: "",
      stockReserved: false,
      cancelRestored: false,
      note: "Shipping amount preserved from the historical example record.",
      exampleRecord: true,
    },
  ];
  const payments = [
    {
      id: "TX-1001",
      orderId: "PO-1001",
      status: "Success",
      method: "UPI",
      reference: "UPI-1001",
      date: "2026-09-25",
      exampleRecord: true,
    },
    {
      id: "TX-1002",
      orderId: "PO-1002",
      status: "Pending",
      method: "Card",
      reference: "CARD-1002",
      date: "2026-09-26",
      exampleRecord: true,
    },
  ];
  return {
    version: LEGACY_VERSION,
    products,
    collections,
    customers,
    orders,
    payments,
    adjustments: [],
    profile: { ...IDENTITY },
    banners: [
      {
        id: "b1",
        title: "Rooted in Age-Old Wisdom.",
        body: "Explore INDRA, VANYA, SUTRA and KALA — everyday pantry collections from Praachin Organics.",
        image: "",
        approved: false,
        active: true,
      },
      {
        id: "b2",
        title: "Your daily pantry, thoughtfully organised.",
        body: "Discover ghee, honey, tea, coffee and snacks in our launch collections.",
        image: "",
        approved: false,
        active: false,
      },
    ],
    settings: {
      legalEntity: IDENTITY.company,
      brand: IDENTITY.brand,
      businessEmail: IDENTITY.businessEmail,
      businessPhone: IDENTITY.phone,
      supportEmail: IDENTITY.businessEmail,
      supportPhone: "9175319960",
      address: "Shop no 19, Balaji Arcade, Rajurunagar Pune",
      currency: "INR",
      gstInclusive: true,
      minimumOrder: 350,
      shippingFee: 60,
      freeThreshold: 1499,
      coverage: "India",
      cod: false,
      partialShipments: false,
      dispatchEstimate: "2–3 business days",
      weekendProcessing: false,
      courierConnected: false,
      razorpayConnected: false,
      razorpayKyc: false,
      shippingMode: "Fixed fee",
      policiesApproved: false,
      promotion: {
        code: "PRAACHIN15",
        active: true,
        percent: 15,
        minimum: 1499,
        newOnly: true,
        stacking: false,
        welcome15: false,
        launchActive: false,
        launchPercent: 15,
        bundleActive: false,
        bundlePercent: 18,
        bundleSkus: [],
      },
      policies: {
        privacy:
          "Draft: explain what account, order and contact data is collected, why it is used, and how customers may request help. Requires legal review.",
        terms:
          "Draft: INR prices include GST. India-only shipping and online payments. Minimum order ₹350. Requires legal review.",
        refund:
          "Draft: cancellation can be requested before dispatch. Return, damaged item, replacement and refund eligibility require legal review.",
        shipping:
          "Draft: standard shipping ₹60; free shipping when merchandise value is strictly above ₹1,499. Dispatch estimate 2–3 business days. Requires legal review.",
      },
      content: {
        story: "Rooted in Age-Old Wisdom. Made for Modern Living.",
        announcement: "Explore our launch collections.",
        foodWisdom:
          "Draft: add approved food stories, recipes and sourcing articles.",
      },
    },
    notificationsRead: [],
  };
}
export function snapshot(p, s, qty) {
  return {
    productId: p.id,
    skuId: s.id,
    qty,
    price: s.price,
    name: p.name,
    sku: s.code,
    variant: s.variant || p.variant,
    quantity: s.qty,
    unit: s.unit,
    photo: p.photos[0] || "",
    collectionId: p.collection,
    collectionName: p.collection === "VANYA" ? "ARANYA" : p.collection,
  };
}
function fill(obj, defaults) {
  const out = { ...defaults, ...obj };
  for (const [k, v] of Object.entries(defaults))
    if (out[k] === undefined || out[k] === null || out[k] === "")
      out[k] = structuredClone(v);
  return out;
}
function legacyMigrate(old) {
  if (!old) return seed();
  if (old.version >= LEGACY_VERSION) return old;
  const base = legacySeed(),
    d = structuredClone(old);
  d.version = LEGACY_VERSION;
  d.collections = (d.collections || base.collections).map((c) =>
    fill(c, {
      id: c.id,
      code: c.id,
      name: c.id,
      description: "Pantry collection",
      order: 1,
      launch: false,
      image: "",
      archived: false,
    }),
  );
  d.products = (d.products || base.products).map((p) => {
    const original = p.skus || [],
      template =
        base.products.find(
          (x) =>
            x.id === p.id && x.name.toLowerCase() === p.name?.toLowerCase(),
        ) || emptyProduct(p.id, "s-" + p.id);
    let n = fill(p, template);
    n.skus = original.length
      ? original.map((s, i) =>
          fill(
            s,
            template.skus[i] || {
              ...template.skus[0],
              id: s.id || "s-" + p.id + "-" + i,
              code: `PO-CUSTOM-${p.id}-${i + 1}`,
            },
          ),
        )
      : template.skus;
    n.photos = p.photos ?? template.photos;
    n.provenance = { ...template.provenance, ...p.provenance };
    return n;
  });
  // Duplicate codes can occur in old custom rows; retain valid codes and fill only unknown ones.
  const used = new Set();
  for (const p of d.products)
    for (const s of p.skus) {
      if (!s.code || used.has(s.code.toUpperCase()))
        s.code = `PO-${p.id.toUpperCase()}-${s.id.toUpperCase()}`;
      used.add(s.code.toUpperCase());
    }
  d.customers = (d.customers || base.customers).map((c) => {
    const def = base.customers.find((x) => x.id === c.id);
    if (c.name === "Anaya Demo" || c.name === "Rohan Demo")
      return {
        ...c,
        name: def.name,
        email: c.email?.endsWith("@example.invalid") ? def.email : c.email,
        phone: c.phone === "0000000000" ? "" : c.phone,
        note: c.note === "Fictional test customer" ? def.note : c.note,
        exampleRecord: true,
      };
    return { ...c, exampleRecord: c.exampleRecord ?? true };
  });
  d.orders = (d.orders || base.orders).map((o) => ({
    ...o,
    discount: o.discount ?? 0,
    stockReserved: o.stockReserved ?? false,
    cancelRestored: o.cancelRestored ?? false,
    items: o.items.map((i) => {
      const p = d.products.find((x) => x.id === i.productId),
        s = p?.skus.find((x) => x.id === i.skuId);
      return {
        ...(p && s
          ? snapshot(p, s, i.qty)
          : { name: "Historical item", sku: i.skuId }),
        ...i,
      };
    }),
  }));
  d.payments = d.payments || base.payments;
  const orderAliases = { "DEMO-1001": "PO-1001", "DEMO-1002": "PO-1002" },
    paymentAliases = { tx1: "TX-1001", tx2: "TX-1002" };
  for (const o of d.orders) {
    if (orderAliases[o.id]) {
      o.legacyId = o.id;
      o.id = orderAliases[o.id];
    }
    o.paymentId = paymentAliases[o.paymentId] || o.paymentId;
    if (o.note === "Fictional order")
      o.note = "Email delivery update requested.";
    else if (o.note?.startsWith("Fictional order;"))
      o.note = "Historical shipping amount preserved.";
  }
  for (const p of d.payments) {
    p.id = paymentAliases[p.id] || p.id;
    p.orderId = orderAliases[p.orderId] || p.orderId;
    p.method = p.method?.replace(" (simulated)", "");
    p.reference = p.reference?.replace(/^DEMO-/, "REF-");
  }
  d.adjustments = d.adjustments || [];
  const legacyEmail = d.profile?.email;
  const wasDefault =
    !d.profile?.name || d.profile.name === "Demo administrator";
  d.profile = fill(d.profile || {}, IDENTITY);
  if (wasDefault) d.profile.name = IDENTITY.name;
  if (
    legacyEmail &&
    legacyEmail !== "admin.demo@example.invalid" &&
    !old.profile?.businessEmail
  )
    d.profile.businessEmail = legacyEmail;
  const prior = d.settings || {};
  d.settings = fill(prior, base.settings);
  for (const k of ["shippingFee", "freeThreshold", "minimumOrder"])
    if (prior[k] == null) d.settings[k] = base.settings[k];
  if (prior.shippingMode === "Pending confirmation")
    d.settings.shippingMode = "Fixed fee";
  if (d.profile.email === "admin.demo@example.invalid") delete d.profile.email;
  d.settings.promotion = fill(prior.promotion || {}, base.settings.promotion);
  d.settings.policies = fill(prior.policies || {}, base.settings.policies);
  d.settings.content = fill(prior.content || {}, base.settings.content);
  d.banners = (d.banners || base.banners).map((b) =>
    b.id === "b1" &&
    b.body ===
      "Praachin Organics — a draft homepage banner awaiting content approval."
      ? { ...b, body: base.banners[0].body }
      : fill(b, base.banners[0]),
  );
  d.notificationsRead = d.notificationsRead || [];
  return d;
}

export function seed() {
  const d = legacySeed();
  for (const c of d.customers) Object.assign(c, customerExamples[c.id] || {});
  return renameHoneyCollection(upgrade(d));
}
export function migrate(old) {
  const d = legacyMigrate(old);
  if (old?.version < 4)
    for (let o = 0; o < d.orders.length; o++)
      for (let i = 0; i < d.orders[o].items.length; i++)
        if (!old.orders?.[o]?.items?.[i]?.collectionId) {
          delete d.orders[o].items[i].collectionId;
          delete d.orders[o].items[i].collectionName;
        }
  return renameHoneyCollection(upgrade(d));
}

// Naming correction only. Stable collection IDs and SKU codes remain unchanged.
export function renameHoneyCollection(d) {
  const rename = (value) =>
    typeof value === "string" ? value.replace(/\bVANYA\b/gi, "ARANYA") : value;
  for (const c of d.collections || []) {
    if (/^vanya$/i.test(c.name || "")) c.name = "ARANYA";
    if (/^vanya$/i.test(c.code || "")) c.code = "ARANYA";
    c.description = rename(c.description);
  }
  for (const p of d.products || []) p.description = rename(p.description);
  for (const o of d.orders || [])
    for (const item of o.items || [])
      if (/^vanya$/i.test(item.collectionName || ""))
        item.collectionName = "ARANYA";
  for (const b of d.banners || []) {
    b.title = rename(b.title);
    b.body = rename(b.body);
  }
  for (const [key, value] of Object.entries(d.settings?.content || {}))
    d.settings.content[key] = rename(value);
  return d;
}
